import { render } from "./CashPayment.vue?vue&type=template&id=3218d5d2&scoped=true"
import script from "./CashPayment.vue?vue&type=script&lang=js"
export * from "./CashPayment.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=3218d5d2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3218d5d2"]])

export default __exports__